import FetchHelper from '../../helpers/fetch_helper';

const AdminFinancingRequestsDispatcher = {
  async lockAdminFinancingRequest(id) {
    let promise;
    try {
      const url = `admin/financing-requests/${id}`;
      promise = await FetchHelper.fetchJson(url, { method: 'PUT', body: { lockedForEditing: true } });
      this.setStoreVal('adminFinancingRequest', promise.results[0]);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not lock Financing Request' },
      });
    }
    return promise;
  },

  async unlockAdminFinancingRequest(id) {
    let promise;
    try {
      const url = `admin/financing-requests/${id}`;
      promise = await FetchHelper.fetchJson(url, { method: 'PUT', body: { lockedForEditing: false } });
      this.setStoreVal('adminFinancingRequest', promise.results[0]);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not unlock Financing Request' },
      });
    }
    return promise;
  },
};

export default AdminFinancingRequestsDispatcher;
